import { CreateProjectPartOneValues } from 'types/validators/project-validators';

// Static fields that are not in the config registry are mapped here
// so that they can also be saved to the config table
export const FIRST_STEP_CONFIG_MAPPING = [
  { configKey: 'utility_name', fieldName: 'name' as keyof CreateProjectPartOneValues },
  { configKey: 'utilityID', fieldName: 'projectId' as keyof CreateProjectPartOneValues },
  { configKey: 'supported_meter_types', fieldName: 'meterTypes' as keyof CreateProjectPartOneValues },
  { configKey: 'allowed_measurement_type', fieldName: 'fuelTypes' as keyof CreateProjectPartOneValues },
  { configKey: 'default_user_segment', fieldName: 'customerSegment' as keyof CreateProjectPartOneValues }
] as const;
//todo : need to maintain this at db level
export type ConfigMapping = typeof FIRST_STEP_CONFIG_MAPPING[number]; 